import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routePurchaseInvoiceCreate,
  detail: routePurchaseInvoiceDetail,
  home: routePurchaseInvoicesHome,
  root: routePurchaseInvoicesRoot,
} = createDoctypeRoutes({
  createName: 'new-purchase-invoice',
  createPath: 'new-purchase-invoice',
  detailName: 'purchaseInvoiceDetail',
  doctype: DOCTYPES.PURCHASE_INVOICE,
  homeName: 'purchase-invoices-home',
  path: 'purchase-invoices',
  views: {
    create: async () =>
      await import('@/components/viewsExternal/purchaseInvoices/AddPurchaseInvoice.vue'),
    detail: async () =>
      await import('@/components/viewsExternal/purchaseInvoices/ViewPurchaseInvoice.vue'),
    list: async () =>
      await import('@/components/viewsExternal/purchaseInvoices/PurchaseInvoiceView.vue'),
  },
})

export {
  routePurchaseInvoiceCreate,
  routePurchaseInvoiceDetail,
  routePurchaseInvoicesHome,
  routePurchaseInvoicesRoot,
}
